import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout/Layout';
import { ScrollToTop } from './components/ScrollToTop/ScrollToTop';

// Pages
import { Home } from './pages/Home/Home';
import { Games } from './pages/Games/Games';
import { Game } from './pages/Game/Game';
import { GameTracker } from './pages/GameTracker/GameTracker';
import { Presskit } from './pages/Presskit/Presskit';
import { Article } from './pages/Article/Article';
import { Contact } from './pages/Contact/Contact';
import { About } from './pages/About/About';
import { NotFound } from './pages/NotFound/NotFound';
import { Redirect } from './pages/Redirect/Redirect';
import { Privacy } from './pages/Privacy/Privacy';
export const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/games" element={<Games />} />
          <Route path="/games/:slug/presskit" element={<Presskit />} />
          <Route path="/games/:slug" element={<Game />} />
          <Route path="/game-tracker" element={<GameTracker />} />
          <Route path="/article/:slug" element={<Article />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/r/:slug" element={<Redirect />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
};